import styled from 'styled-components';

import { Color } from '../../../../constants/Colors';
import { FontSize, FontType, FontWeight } from '../../../../constants/Fonts';
import { MediaQuery } from '../../../../constants/Styles';

export const Typewriter = styled.span`
  font-size: 54px;
  font-weight: ${FontWeight.BLACK};
  font-family: ${FontType.PRIMARY};

  background: linear-gradient(
    180deg,
    ${Color.BLUE_DODGER} 0%,
    ${Color.BLUE_RIBBON} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;

  ${MediaQuery.S_AND_DOWN} {
    font-size: ${FontSize.XXXXXL};
  }
`;
